import { render, staticRenderFns } from "./registro_edicion_fromulario.vue?vue&type=template&id=e5aad36a&scoped=true"
import script from "./registro_edicion_fromulario.vue?vue&type=script&lang=js"
export * from "./registro_edicion_fromulario.vue?vue&type=script&lang=js"
import style0 from "./registro_edicion_fromulario.vue?vue&type=style&index=0&id=e5aad36a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5aad36a",
  null
  
)

export default component.exports